<div class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm animate-fade-in"
  (click)="onClose()">
  <div
    class="relative w-full max-w-lg bg-white dark:bg-slate-900 rounded-[2rem] shadow-2xl border border-slate-100 dark:border-slate-800 flex flex-col max-h-[92vh] overflow-hidden animate-fade-in-up"
    (click)="$event.stopPropagation()">

    <div *ngIf="isLoading()"
      class="absolute inset-0 bg-white/80 dark:bg-slate-900/80 z-50 flex items-center justify-center rounded-[2rem]">
      <div class="w-10 h-10 border-4 border-amber-400 border-t-transparent rounded-full animate-spin"></div>
    </div>

    <div class="flex-none px-6 md:px-8 py-5 border-b border-slate-100 dark:border-slate-800 flex items-center justify-between gap-4 bg-white dark:bg-slate-900">
      <div>
        <h3 class="text-xl font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
          <span class="material-icons text-amber-500">{{ isEdit ? 'edit' : 'gavel' }}</span>
          {{ isEdit ? 'แก้ไข Penalty Rate' : 'เพิ่ม Penalty Rate' }}
        </h3>
        <p class="text-sm text-slate-500 dark:text-slate-400 mt-1 font-medium">
          กำหนดรหัสค่าปรับ ชื่อ และอัตราค่าปรับ
        </p>
      </div>
      <button type="button" (click)="onClose()" [disabled]="isSaving()"
        class="w-9 h-9 rounded-xl flex items-center justify-center text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors disabled:opacity-50">
        <span class="material-icons">close</span>
      </button>
    </div>

    <div class="flex-1 overflow-y-auto px-6 md:px-8 py-6 custom-scrollbar space-y-5 bg-white dark:bg-slate-900">
      <div>
        <label class="block text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-2">
          Penalty ID <span class="text-rose-500">*</span>
        </label>
        <div class="relative flex items-center bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 dark:focus-within:ring-amber-500/30 h-[46px]">
          <span class="absolute left-3 material-icons text-slate-400 text-lg pointer-events-none">tag</span>
          <input [(ngModel)]="formData.penaltyId" [disabled]="isSaving()" placeholder="เช่น PN001"
            class="w-full h-full pl-10 pr-4 bg-transparent border-none text-sm font-medium focus:outline-none placeholder:text-slate-400 disabled:opacity-50">
        </div>
      </div>

      <div>
        <label class="block text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-2">
          ชื่อ <span class="text-rose-500">*</span>
        </label>
        <div class="relative flex items-center bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 dark:focus-within:ring-amber-500/30 h-[46px]">
          <span class="absolute left-3 material-icons text-slate-400 text-lg pointer-events-none">badge</span>
          <input [(ngModel)]="formData.name" [disabled]="isSaving()" placeholder="ชื่ออัตราค่าปรับ"
            class="w-full h-full pl-10 pr-4 bg-transparent border-none text-sm font-medium focus:outline-none placeholder:text-slate-400 disabled:opacity-50">
        </div>
      </div>

      <div>
        <label class="block text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-2">Over Time</label>
        <div class="relative flex items-center bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 dark:focus-within:ring-amber-500/30 h-[46px]">
          <span class="absolute left-3 material-icons text-slate-400 text-lg pointer-events-none">schedule</span>
          <input [(ngModel)]="formData.overTime" [disabled]="isSaving()" placeholder="เช่น 01:00:00"
            class="w-full h-full pl-10 pr-4 bg-transparent border-none text-sm font-medium focus:outline-none placeholder:text-slate-400 disabled:opacity-50">
        </div>
      </div>

      <div>
        <label class="block text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-2">Fine Price</label>
        <div class="relative flex items-center bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 dark:focus-within:ring-amber-500/30 h-[46px]">
          <span class="absolute left-3 material-icons text-slate-400 text-lg pointer-events-none">payments</span>
          <input type="number" [(ngModel)]="formData.finePrice" [disabled]="isSaving()"
            class="w-full h-full pl-10 pr-4 bg-transparent border-none text-sm font-medium focus:outline-none disabled:opacity-50">
        </div>
      </div>
    </div>

    <div class="flex-none px-6 md:px-8 py-5 border-t border-slate-100 dark:border-slate-800 flex flex-col sm:flex-row justify-between gap-3 bg-white dark:bg-slate-900">
      <button *ngIf="canShowActivityHistory" type="button" (click)="openActivityHistory()" [disabled]="isSaving() || isLoading()"
        class="px-5 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 font-bold text-slate-600 dark:text-slate-300 hover:border-amber-400 hover:text-amber-600 transition-all cursor-pointer inline-flex items-center justify-center gap-2 disabled:opacity-50">
        <span class="material-icons text-[18px]">history</span>
        ดูประวัติ
      </button>
      <div class="flex flex-col sm:flex-row justify-end gap-3 ml-auto">
        <button type="button" (click)="onClose()" [disabled]="isSaving()"
          class="px-5 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 font-bold text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors disabled:opacity-50">
          ยกเลิก
        </button>
        <button type="button" (click)="onSave()" [disabled]="isSaving() || isLoading()"
          class="px-6 py-2.5 rounded-xl bg-amber-400 hover:bg-amber-500 text-white font-bold shadow-lg shadow-amber-200/50 dark:shadow-amber-900/30 transition-all disabled:opacity-50">
          {{ isSaving() ? 'กำลังบันทึก...' : 'บันทึก' }}
        </button>
      </div>
    </div>
  </div>
</div>

<app-modal-admin-activity-history
  *ngIf="showActivityHistory && itemId"
  [entityType]="activityEntityTypes.ParkingPenaltyRate"
  [entityId]="itemId"
  title="ประวัติอัตราปรับ"
  [subtitle]="'#' + itemId"
  (close)="closeActivityHistory()">
</app-modal-admin-activity-history>
